import { createTheme } from '@mui/material/styles';
import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';

export const rtlCache = createCache({
  key: 'muirtl',
  stylisPlugins: [rtlPlugin],
});


export const theme = createTheme({
  direction: 'rtl',
  typography: {
    fontFamily: 'IRANSans, Roboto, sans-serif',
  },
});


